<template>
    <div class="container-fluid">
        <section id="wrapper" class="error-page">
            <div class="error-box">
                <div class="error-body text-center">
                    <h1>500</h1>
                    <h3 class="text-uppercase">Internal Server Error !</h3>
                    <p class="text-muted m-t-30 m-b-30">Please try after some time</p>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    export default {
        name: "500"
    }
</script>